import { render, staticRenderFns } from "./selectHospitalMulti.vue?vue&type=template&id=6e3cd6c1&scoped=true"
import script from "./selectHospitalMulti.vue?vue&type=script&lang=js"
export * from "./selectHospitalMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3cd6c1",
  null
  
)

export default component.exports